import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { cloneDate } from '@progress/kendo-date-math';
import { classNames, useDir } from '@progress/kendo-react-common';
import { useSchedulerPropsContext, useSchedulerViewSlotsContext } from '../context';
import { first, isInTimeRange } from '../utils';
import { getRect } from '../views/common/utils';
var combineWidths = function (slots) {
    var result = 0;
    slots.forEach(function (slot) {
        var rect = getRect(slot.element);
        result += rect.width;
    });
    return result;
};
var combineHeights = function (slots) {
    var result = 0;
    slots.forEach(function (slot) {
        var rect = getRect(slot.element);
        result += rect.height;
    });
    return result;
};
var setTime = function (origin, candidate) {
    var date = cloneDate(origin);
    date.setHours(candidate.getHours(), candidate.getMinutes(), candidate.getSeconds(), candidate.getMilliseconds());
    return date;
};
/** @hidden */
export var CurrentTimeMarker = function (props) {
    var _a;
    var _b = React.useState(false), show = _b[0], setShow = _b[1];
    var schedulerProps = useSchedulerPropsContext();
    var interval = React.useRef(undefined);
    var arrowRef = React.useRef(null);
    var line = React.useRef(null);
    var updateInterval = props.updateInterval || defaultProps.updateInterval;
    var _c = React.useState(false), setForce = _c[1];
    var dir = useDir(line, schedulerProps.rtl === true ? 'rtl' : undefined);
    var slots = useSchedulerViewSlotsContext()[0];
    var position = React.useCallback(function () {
        if (!slots.current) {
            return;
        }
        var sameTimeSlots = slots.current
            .filter(function (s) { return (props.groupIndex === undefined || props.groupIndex === null || s.props.group.index === props.groupIndex)
            && isInTimeRange(new Date(), s.props.start, s.props.end)
            && !s.props.isAllDay; });
        if (sameTimeSlots && sameTimeSlots.length && arrowRef.current && line.current) {
            var firstSlot = first(sameTimeSlots);
            var size = props.vertical
                ? combineHeights(sameTimeSlots)
                : combineWidths(sameTimeSlots);
            var rect = getRect(firstSlot.element);
            var arrowRect = getRect(arrowRef.current);
            var pxPerMillisecond = (props.vertical ? rect.width : rect.height)
                / (firstSlot.props.end.getTime() - firstSlot.props.start.getTime());
            var offset = (Date.now() - setTime(new Date(), firstSlot.props.start).getTime()) * pxPerMillisecond;
            var rtl = dir === 'rtl';
            var top_1 = props.vertical
                ? rect.top
                : rect.top + offset - (arrowRect.height / 2);
            var horizontalDimension = rtl ? 'right' : 'left';
            var horizontalMeasure = props.vertical
                ? rect[horizontalDimension] + offset - (arrowRect.width / 2)
                : rect[horizontalDimension];
            if (props.vertical) {
                arrowRef.current.style[horizontalDimension] = horizontalMeasure + "px";
            }
            else {
                arrowRef.current.style.top = top_1 + "px";
            }
            line.current.style[horizontalDimension] = horizontalMeasure + "px";
            line.current.style.top = top_1 + "px";
            line.current.style[props.vertical ? 'height' : 'width'] = size - 1 + "px";
            setShow(true);
        }
        else {
            setShow(false);
        }
    }, [props.groupIndex, slots.current, props.vertical, props.attachArrow && props.attachArrow.current]);
    var refresh = React.useCallback(function () {
        position();
        setForce(function (f) { return !f; });
    }, [position]);
    React.useEffect(function () {
        if (!window) {
            return;
        }
        clearInterval(interval.current);
        interval.current = window.setInterval(refresh, updateInterval);
        window.addEventListener('resize', position);
        return function () { clearInterval(interval.current); window.removeEventListener('resize', refresh); };
    }, [refresh]);
    React.useEffect(position);
    var arrow = (React.createElement("div", { ref: arrowRef, className: classNames('k-current-time', {
            'k-current-time-arrow-right': !props.vertical && dir !== 'rtl',
            'k-current-time-arrow-left': !props.vertical && dir === 'rtl',
            'k-current-time-arrow-down': props.vertical
        }), style: {
            transform: props.vertical
                ? dir === 'rtl'
                    ? 'translateX(50%)'
                    : 'translateX(-50%)'
                : 'translateY(-50%)',
            visibility: !show ? 'hidden' : undefined
        } }));
    return (React.createElement(React.Fragment, null,
        (props.attachArrow && props.attachArrow.current) ? ReactDOM.createPortal(arrow, props.attachArrow.current) : arrow,
        React.createElement("div", { className: "k-current-time", ref: line, style: (_a = {
                    transform: props.vertical ? 'translateX(-50%)' : 'translateY(-50%)'
                },
                _a[props.vertical ? 'width' : 'height'] = '1px',
                _a.visibility = !show ? 'hidden' : undefined,
                _a) })));
};
var defaultProps = {
    updateInterval: 60000
};
CurrentTimeMarker.defaultProps = defaultProps;
//# sourceMappingURL=CurrentTimeMarket.js.map